/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ComponentProps, type JSX, memo, MouseEvent, ReactElement } from 'react';

import { Button } from '@mui/material';

import { SelectItemCatalogueButton } from '../SelectItemCatalogueButton/SelectItemCatalogueButton';

type Props = {
  buttonProps?: ComponentProps<typeof Button>;
  className: string;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  isActive: boolean;
  autoFocus: boolean;
  icon: JSX.Element;
  optionLabel: string;
  fallback: false | ReactElement<any>;
  key: number;
};

export const SelectItemCatalogueMember = memo<Props>(
  ({ optionLabel, icon, fallback, buttonProps, ...rest }) =>
    fallback || (
      <SelectItemCatalogueButton {...rest} {...buttonProps} data-cy={`select-item-catalogue-${optionLabel}`}>
        {optionLabel}
        {icon}
      </SelectItemCatalogueButton>
    ),
);
